// @ts-ignore - This file is required by gatsby-config.js which uses CommonJS
module.exports = {
  author: 'Everly Health', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.everlywell.com/enterprise/', // URL used for author and publisher schema, can be a social profile or other personal site
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  copyright: `Copyright © ${new Date().getFullYear()} Everly Health Solutions.`, // Copyright string for the RSS feed
  keywords:
    'home health testing, online blood test, online health test, at home blood test, at home lab test, blood test, urine test, saliva test, food intolerance test, food sensitivity test, fertility test, hormone testing, self testing',
  postsPerHomePage: 10, // Number of posts shown on the 1st page of the index.js template (home page)
  postsPerPage: 10, // Number of posts shown on paginated pages
  publisher: 'Everly Health', // Organization name used for SEO schema
  shortTitle: 'Everly Health Solutions', // Used for App manifest e.g. Mobile Home Screen
  siteDescription:
    'Home health testing has never been easier. Order at-home tests directly to your door and get your results online within days.',
  siteLogo: '/enterprise/logo/ew-mark-1024.png', // Logo used for SEO, RSS, and App manifest
  title: 'Everlywell - Innovative at-home Health Testing',
  siteTitle: 'Everlywell - Innovative at-home Health Testing',
  siteTitleAlt: 'Everly Health Solutions', // This allows an alternative site title for SEO schema.
  siteUrl: 'https://www.everlywell.com/enterprise', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  themeColor: '#121212', // Used for Offline Manifest
};
